import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';

const PageLayout = ({ children }) => {
  return (
    <div className="app-with-layout">
      <Header />
      <div className="app-body">
        <Sidebar />
        <main className="main-content-with-sidebar">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default PageLayout;